import { Avatar, AvatarFallback, AvatarImage } from "@/app/components/ui/avatar";
import { cn } from "@/app/lib/utils";

type TaiZenLogoProps = {
   title?: string;
   size?: "xxs" | "xs" | "sm" | "md" | "lg";
   isEffect?: boolean;
   className?: string;
};

const imageSrc = "/data/imgs/Tai-03-Cropped-Brightend-Thin-4-use-this-225x300.png";
export const TaiZenLogo = (props: TaiZenLogoProps) => {
   const { title, size = "md", isEffect = false, className = "" } = props;

   return (
      <div className="flex flex-col space-y-2 text-center">
         <Avatar
            className={cn(
               "mx-auto w-56 h-56",
               size === "xxs" && "w-12 h-12",
               size === "xs" && "w-16 h-16",
               size === "sm" && "w-24 h-24",
               size === "md" && "w-56 h-56",
               size === "lg" && "w-72 h-72",
               isEffect && "zen-logo",
               className
            )}
         >
            <AvatarImage
               src={imageSrc}
               alt="@TaiZenAI"
               className={cn("select-none object-contain w-full h-full")}
            />
            <AvatarFallback className="text-[9px] font-semibold">TaiZenAi</AvatarFallback>
         </Avatar>
         {title && <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>}
      </div>
   );
};
